import { createSlice } from '@reduxjs/toolkit';
import { dispatcher } from '../../helpers/projectHelper';

const _addToCollection = createSlice({
  name: 'addToCollection',
  initialState: {
    items: [],
    modelType: null,
    copyInfo: {
      hasCopiedEdits: false,
      id: null,
    }
    
  },
  reducers: {
    add: (state, { payload: { modelType, items } }) => {
      state.items.push(...items);
      state.modelType = modelType;
    },
    clear: (state) => {
      state.items = [];
      state.modelType = null;
    },
    setCopyInfo: (state, { payload }) => {
      state.copyInfo = payload;
    }
  },
});

export const addToCollectionActions = _addToCollection.actions;
export const addToCollectionSelector = (state) => state.addToCollection;
export const addToCollectionReducer = _addToCollection.reducer;
export default addToCollectionReducer;

export const selectAddToCollectionItems = (state) => state.addToCollection.items
export const selectCopyInfo = (state) => state.addToCollection.copyInfo
export const selectAddToCollectionModelType = (state) => state.addToCollection.modelType


export const addToCollection = ({ items, modelType }) => {
  dispatcher(addToCollectionActions.add({
    items,
    modelType,
  }))
}